import { render, staticRenderFns } from "./participated.vue?vue&type=template&id=c20c7a72&scoped=true"
import script from "./participated.vue?vue&type=script&lang=js"
export * from "./participated.vue?vue&type=script&lang=js"
import style0 from "./participated.vue?vue&type=style&index=0&id=c20c7a72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c20c7a72",
  null
  
)

export default component.exports